import React from 'react';
import { Link } from 'react-router-dom';
import { business, services } from './siteData';
import {
  FooterBottom,
  FooterBrand,
  FooterGrid,
  FooterLinkList,
  FooterWrapper,
} from './styled/footer.style';

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterGrid>
        <FooterBrand>
          <span>{business.name}</span>
          <p>
            Drywall installation, finishing, steel framing, ceiling tile grid,
            and drywall repair for homes and businesses across {business.serviceArea}.
          </p>
        </FooterBrand>
        <FooterLinkList aria-label="Footer navigation">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about">About KMK Drywall</Link>
          </li>
          <li>
            <Link to="/quote">Request a Quote</Link>
          </li>
        </FooterLinkList>
        <FooterLinkList aria-label="Drywall services">
          {services.slice(0, 6).map((service) => (
            <li key={service.title}>{service.title}</li>
          ))}
        </FooterLinkList>
        <FooterLinkList aria-label="Contact KMK Drywall">
          <li>
            <a href={business.phoneHref}>{business.phoneDisplay}</a>
          </li>
          <li>
            <a href={business.emailHref}>{business.email}</a>
          </li>
          <li>Springville, NY</li>
          <li>Serving Buffalo and Erie County</li>
        </FooterLinkList>
      </FooterGrid>
      <FooterBottom>
        <span>&copy; {new Date().getFullYear()} {business.name}</span>
        <span>Professional drywall services in Western New York</span>
      </FooterBottom>
    </FooterWrapper>
  );
};

export default Footer;
